<template>
  <div class="custom-padding-bottom-10px custom-padding-left-10px custom-height-100p">
    <a-row>
      <div class="title custom-flex">
        <div class="icon" />
        <span>订单趋势</span>
      </div>
    </a-row>
    <a-spin
      :spinning="loading"
    >
      <div
        ref="orderChart"
        style="height: 220px"
      />
    </a-spin>
  </div>
</template>

<script>
import { findTenantHomePageOrderStatisticsTrend } from '@/api/home'
import { formatBigNumber } from '@/utils/filter'

export default {
  name: 'OrderDataTrendStatistics', // 订单折线图
  data() {
    this.handleWindowResize = this.$lodash.throttle(this.handleWindowResize, 1000)
    return {
      chart: null,
      statistics: [],
      loading: true
    }
  },
  created() {
    window.addEventListener('resize', this.handleWindowResize)
  },
  mounted() {
    this.fetchData()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  computed: {
    chartOption() {
      return {
        tooltip: {
          trigger: 'axis',
          position: (point, params, dom, rect, size) => {
            // size为当前窗口大小
            if ((size.viewSize[0] / 2) >= point[0]) {
              // 其中point为当前鼠标的位置
              return [point[0] + 20, '10%']
            } else {
              // 其中point为当前鼠标的位置
              return [point[0] - 200, '10%']
            }
          },
          formatter: (params) => {
            let relVal = params[0].name
            relVal += `<br/>${params[0].marker}${formatBigNumber(params[0].value)}单`
            return relVal
          }
        },
        legend: { data: [], type: 'scroll' },
        grid: { x: 30, y: 50, x2: 0, y2: 20 },
        xAxis: { type: 'category', data: [] },
        yAxis: { type: 'value' },
        series: []
      }
    }
  },
  methods: {
    handleWindowResize() {
      this.chart && this.chart.resize()
    },

    // 用于设置渐变色
    setSeries() {
      // 从全局色中获取一个颜色
      const seriesColor = this.chart._theme.color[0]
      this.chartOption.series = {
        name: '',
        data: this.$lodash.map(this.statistics, 'count'),
        type: 'line',
        color: seriesColor,
        areaStyle: {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: seriesColor
            },
            {
              offset: 0.8,
              color: 'rgba(255, 255, 255, 0)'
            }
          ])
        }
      }
    },

    drawChart() {
      let value = []
      this.statistics.forEach(statistic => {
        if (!value.includes(statistic.name)) {
          value.push(statistic.name)
        }
      })
      value = value.sort(
        (a, b) => new Date(a).getTime() - new Date(b).getTime()
      )
      this.chart ||= this.$echarts.init(this.$refs.orderChart, 'echarts_custom')
      this.chartOption.xAxis.data = this.$lodash.map(value)
      this.chartOption.series = []
      this.setSeries()
      this.chart.setOption(this.chartOption, true)
    },

    fetchData() {
      this.loading = true
      findTenantHomePageOrderStatisticsTrend({}).then((res) => {
        if (res.code === 0) {
          this.statistics = res.data
          this.drawChart()
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 14px;

  .icon {
    margin: 3px 3px 0 0;
    width: 3px;
    height: 15px;
    background-color: @primary-color;
  }
}
</style>
